import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  async setStorage(key: string, value: string) {
    console.log(`[STORAGE] Setting ${key} - START`);
    const result = await Preferences.set({ key, value });
    console.log(`[STORAGE] Setting ${key} - COMPLETE`);
    return result;
  }

  async getStorage(key: string) {
    console.log(`[STORAGE] Getting ${key} - START`);
    const result = await Preferences.get({ key });
    console.log(`[STORAGE] Getting ${key} - COMPLETE`, result.value ? 'HAS VALUE' : 'NO VALUE');
    return result;
  }

  async removeStorage(key: string) {
    console.log(`[STORAGE] Removing ${key} - START`);
    const result = await Preferences.remove({ key });
    console.log(`[STORAGE] Removing ${key} - COMPLETE`);
    return result;
  }
}
